import HoveredImage from '../shared/HoveredImage';
import { Box } from 'theme-ui';
import { combineText } from '../../../functions/combineText';
import HeroDescription from './HeroDescription';

const styles = {
  heroOuter: {
    textAlign: 'center',
  },

  flexBox: {
    padding: '0 30px 30px',
    h5: {
      fontWeight: 700,
    },
    img: {
      width: '60px',
      marginBottom: '1em',
    },
  },
  flex: {
    paddingTop: '27px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
};

export interface HeroProps {
  staticContent: any;
  dynamicContent: any;
  buttonText: string;
  isTest: boolean
}

const Hero: React.FC<HeroProps> = ({
  staticContent,
  dynamicContent,
  buttonText,
  isTest
}) => {
  return (
    <Box sx={styles.heroOuter}>
      <HoveredImage
        image={dynamicContent.heroImage}
        header1={
          dynamicContent?.heroTitle ||
          combineText(staticContent?.heroImage?.kicker?.text || '', [
            dynamicContent?.service?.name || '',
          ]) ||
          ''
        }
        header2={
          dynamicContent?.heroText1 ||
          combineText(
            combineText(staticContent?.heroImage?.title?.text || '', [
              dynamicContent?.service?.name || '',
            ]) || '',
            [dynamicContent?.numberOfPerson || '']
          ) ||
          ''
        }
        header3={
          dynamicContent?.heroPrice ||
          combineText(staticContent?.heroImage?.text_1?.text || '', [
            dynamicContent?.sharedPrice || '',
          ]) ||
          ''
        }
        button={{
          ...staticContent.heroImage.buttons[0],
          text: buttonText,
          link:
            staticContent.heroImage.buttons[0].link +
            (dynamicContent?.queryParams || ''),
        }}
        eagerImage
      />
      {staticContent?.heroDescription &&
        Object.keys(staticContent?.heroDescription).length !== 0 && (
          <HeroDescription
            dynamicContent={dynamicContent}
            staticContent={staticContent?.heroDescription}
            isTest={isTest}
          />
        )}
    </Box>
  );
};
export default Hero;
